/**
 * Commonplace logo — uses the actual brand wordmark image files.
 * Extracted from the official Commonplace Branding Guide PDF.
 */
import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { RD } from '../theme/colors';

// Logo image assets (extracted from brand guide)
const logoMaroon = require('../../assets/logo-maroon.png');
const logoDark   = require('../../assets/logo-dark.png');
const logoWhite  = require('../../assets/logo-white.png');

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'dark' | 'light' | 'maroon';
}

const SIZES = {
  sm: { width: 150, height: 28 },
  md: { width: 200, height: 37 },
  lg: { width: 280, height: 51 },
};

export function Logo({ size = 'md', variant = 'maroon' }: LogoProps) {
  const dims = SIZES[size];
  const source = variant === 'light' ? logoWhite
               : variant === 'dark'  ? logoDark
               : logoMaroon;

  return (
    <View style={styles.wrapper}>
      <Image
        source={source}
        style={{ width: dims.width, height: dims.height }}
        resizeMode="contain"
      />
    </View>
  );
}

/**
 * The icon mark — standalone circular badge with ∞ symbol.
 */
export function LogoMark({ size = 40, light = false }: { size?: number; light?: boolean }) {
  const { Text } = require('react-native');
  const bg = light ? '#fff' : RD.maroon;
  const fg = light ? RD.maroon : '#fff';

  return (
    <View style={[styles.mark, { width: size, height: size, borderRadius: size / 2, backgroundColor: bg }]}>
      <Text style={{ fontSize: size * 0.45, color: fg, fontWeight: '700' }}>{'∞'}</Text>
    </View>
  );
}

/** Full lockup: centered wordmark (used on login/register headers) */
export function LogoLockup({ light = false }: { light?: boolean }) {
  return (
    <View style={styles.lockup}>
      <Logo size="md" variant={light ? 'light' : 'dark'} />
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: { alignItems: 'center' },
  mark:    { justifyContent: 'center', alignItems: 'center' },
  lockup:  { alignItems: 'center' },
});
